import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const INVENTORY_LOCATIONS_INVENTORY_LOCATION_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/inventory-locations',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:InventoryLocations',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.InventoryLocations',
      },
    ]);
  };
}
